<template>
  <div class="comp-container" v-if="results.length > 0">
    <div class="result-container">
      <div
        @click="setResult(person)"
        class="result"
        v-for="person in results"
        :key="person.id"
      >
        <img v-if="person.image" :src="person.imageUrl" />
        <img v-if="!person.image" />
        <div class="info">
          <p>{{ person.name }}</p>
          <v-chip
            class="ma-2"
            x-small
            v-for="movie in person.knownFor"
            :key="movie.id"
          >
            {{ movie.name }}</v-chip
          >
        </div>
      </div>
    </div>
    <div>Keep typing to find your actor</div>
  </div>
</template>

<script>
import axios from "axios";
import environment from "../../env";
export default {
  props: {
    term: {
      type: String,
    },
    actor: {
      type: Number,
    },
  },
  data: () => {
    return {
      total_results: 0,
      results: [],
      searchTerm: "",
    };
  },
  watch: {
    term: function () {
      console.log("term changed");
      if (this.term.length > 3) this.search(this.term);
      if (this.term.length <= 3) this.results = [];
    },
    searchTerm: function () {
      console.log("search term changed");
    },
    deep: true,
  },
  methods: {
    search(term) {
      this.results = [];
      axios
        .get(
          `https://api.themoviedb.org/3/search/person?api_key=${
            environment.APIKEY
          }&language=en-US&query=${JSON.stringify(
            term
          )}&page=1&include_adult=false`
        )
        .then((res) => {
          console.log(res);
          this.total_results = res.data.total_results;
          if (this.total_results > 0) {
            console.log("there are results");
            this.results = res.data.results.map((person) => ({
              id: person.id,
              name: person.name,
              image: person.profile_path,
              knownFor: person.known_for.map((movie) => ({
                name: movie.name ? movie.name : movie.original_title,
                id: movie.id,
              })),
              imageUrl: person.image
                ? "https://eu.ui-avatars.com/api/?name=" + person.name
                : "https://image.tmdb.org/t/p/w45" + person.profile_path,
            }));
          }
          console.log(this.results);
        });
    },
    setResult(person) {
      this.$emit("id", person.id);
      this.$emit("name", person.name);
      this.results = [];
    },
  },
};
</script>

<style scoped>
.comp-container {
  width: 100%;
  position: absolute;
  background: white;
  z-index: 2;
}
.result-container {
  max-height: 200px;
  overflow-y: scroll;
  margin-top: -30px;
  background: white;
}
.result {
  border-bottom: 1px solid lightgrey;
  height: 50px;
  display: flex;
}
.result img {
  height: 50px;
}
.result p {
  margin-bottom: 0;
}
.info {
  overflow: hidden;
  /* padding-top: 10px; */
  display: inline-block;
}
</style>